import { render } from "./Archive.vue?vue&type=template&id=5970e292&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=5970e292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5970e292"]])

export default __exports__